import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk, faInfoCircle, faAddressBook, faShoppingBasket, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { useCart } from '../../context/CartContext';
import './index.css'
import logo_hogcloud1 from "../../assets/images/hogcloud-logo1.svg";


const Navbar = () => {
  const { cart } = useCart();
  const total = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);

  return (
    <nav>
      <ul>
        <li>
          <NavLink to="/" className={({isActive}) => isActive ? 'active2 logo-link' : 'inactive logo-link'}>
            <img 
              src={logo_hogcloud1} 
              alt="hogcloud logo pig in cloud" 
              className="hc_logo_small responsive-logo"
            />
          </NavLink>
        </li>
        <li>
            { false ? (<NavLink to="/services" className={({ isActive }) => isActive ? "active" : ""}>
                    <FontAwesomeIcon icon={faFloppyDisk} className='active hc-nav-icon-spacing' />
                    Services
            </NavLink>) : null }
        </li>   
        <li>
          <NavLink to="/shop" className={({ isActive }) => isActive ? "active" : ""}>
            <FontAwesomeIcon icon={faShoppingBasket} className='active hc-nav-icon-spacing' />
            Shop
          </NavLink>
        </li>         
        <li>
          <NavLink to="/about" className={({ isActive }) => isActive ? "active" : ""}>
            <FontAwesomeIcon icon={faInfoCircle} className='active hc-nav-icon-spacing' />
            About
          </NavLink>
        </li>        
        <li>
          <NavLink to="/contact" className={({ isActive }) => isActive ? "active" : ""}>
            <FontAwesomeIcon icon={faAddressBook} className='active hc-nav-icon-spacing' />
            Contact
          </NavLink>
        </li>
        <li className="right-aligned">
          <NavLink to="/cart" className={({ isActive }) => isActive ? "active" : ""}>
            <FontAwesomeIcon 
              icon={faShoppingCart} 
              className={`active hc-nav-icon-spacing ${cart.length > 0 ? 'cart-glow' : ''}`}
            />
            <div>{showCartNavText(total)}</div>
          </NavLink>
        </li>
      </ul>
      
    </nav>
  );
};

const showCartNavText = (total: number): string => {
  let currentTotal: number = total;

  let cartText = "Cart";

  if (currentTotal > 0) {
    cartText = `$${currentTotal}`;
  }

  return cartText;
};

export default Navbar;
